import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import TgIm from '../components/TgIm';
import Loading from '../components/Loading';

// 创建邀约案件
const InviteCase = lazy(() => import('../components/InviteCase/InviteCase'));
// 企业律所库列表
const LawLibrary = lazy(() => import('../components/LawLibrary/LawLibrary'));
// 用户协议
const UserAgreement = lazy(() => import('../components/UserAgreement'));
// 立即咨询
const Consult = lazy(() => import('../components/Website/Consult'));
const Website = lazy(() => import('../components/Website/Website'));
// 候选库
const Candidate = lazy(() => import('../components/Candidate/candidate'));
const CandidateDetail = lazy(() => import('../components/Candidate/add/CandidateDetail'));
// 律所列表
const LawOffice = lazy(() => import('../components/Attorney/lawOffice'));
const LawOfficeDetails = lazy(() => import('../components/Attorney/Details/lawOfficeDetails'));
const Judicial = lazy(() => import('../components/Attorney/Details/judicial'));
// 案件详情
const CaseDetail = lazy(() => import('../components/Attorney/Details/caseDetail'));
// 更过功能
const MoreInformation = lazy(() => import('../components/Home/moreInformation/moreInformation'));
// 日程
const Calendar = lazy(() => import('../components/Calendar/Index'));
const NewEditor = lazy(() => import('../components/Calendar/NewEditor'));
// 律师案例列表
const LawyerCase = lazy(() => import('../components/Attorney/Details/allCase'));
const LawyerCaseOther = lazy(() => import('../components/Attorney/Details/allCaseOther'));

const ErrorBoundary = lazy(() => import('../components/ErrorBoundary/ErrorBoundary'));
const App = lazy(() => import('../App'));
const Home = lazy(() => import('../components/Home/Home'));
const AllCase = lazy(() => import('../components/LegalCase/legalCase'));
const LegalCase = lazy(() => import('../components/LegalCase/legalCase'));
const LegalCaseDetail = lazy(() => import('../components/LegalCase/legalCaseDetail'));
const Attorney = lazy(() => import('../components/Attorney/attorney'));
const LawyerDetails = lazy(() => import('../components/Attorney/Details/lawyerDetails'));
const PastDue = lazy(() => import('../components/PastDue'));
const My = lazy(() => import('../components/My'));
const CallingCardShare = lazy(() => import('../components/CallingCardShare'));
const Examine = lazy(() => import('../components/CallingCard/examine'));
// 律师名片
const CallingCard = lazy(() => import('../components/CallingCard'));
const StudyList = lazy(() => import('../components/CallingCard/StudyList/Index'));
// 律师认证
const Credentials = lazy(() => import('../components/Credentials/Credentials.js'));
// 律师认证 - 案例
const CredentialsCase = lazy(() => import('../components/Credentials/CredentialsCase.js'));
// 律师认证成功页面
const LawyerSuccess = lazy(() => import('../components/Credentials/LawyerSuccess'));
const Im = lazy(() => import('../components/Im/im'));
// 荣誉详情
const HonorDetail = lazy(() => import('../components/CallingCard/common/HonorDetail'));
// 新增/编辑荣誉
const CompileHonor = lazy(() => import('../components/CallingCard/common/compileHonor'));
// 新增/编辑工作经历
const WorkChange = lazy(() => import('../components/CallingCard/common/WorkChange'));
// 新增/编辑教育经历
const EducationChange = lazy(() => import('../components/CallingCard/common/EducationChange'));
// 合作列表
const CooperList = lazy(() => import('../components/CallingCard/CooperList'));

function Routers() {
    return (
        <Router>
            <Suspense fallback={<Loading />}>
                <ErrorBoundary>
                    <App>
                        <Switch>
                            <Route path="/homePage" component={Home} />
                            <Route path="/attorney" component={Attorney} />
                            <Route path="/allCase" component={AllCase} />
                            <Route path="/legalCase" component={LegalCase} />
                            <Route path="/legalCaseDetail" component={LegalCaseDetail} />
                            <Route path="/consult" component={Consult} />
                            <Route path="/website" component={Website} />
                            <Route path="/candidate" component={Candidate} />
                            <Route path="/lawOfficeDetails" component={LawOfficeDetails} />
                            <Route path="/lawyerCase" component={LawyerCase} />
                            <Route path="/lawyerCaseOther" component={LawyerCaseOther} />
                            <Route path="/lawyerDetails" component={LawyerDetails} />
                            <Route path="/inviteCase" component={InviteCase} />
                            <Route path="/lawLibrary" component={LawLibrary} />
                            <Route path="/userAgreement" component={UserAgreement} />
                            <Route path="/consult" component={Consult} />
                            <Route path="/website" component={Website} />
                            <Route path="/candidate" component={Candidate} />
                            <Route path="/candidateDetail" component={CandidateDetail} />
                            <Route path="/lawOffice" component={LawOffice} />
                            <Route path="/moreInformation" component={MoreInformation} />
                            <Route path="/lawOfficeDetails" component={LawOfficeDetails} />
                            <Route path="/judicial" component={Judicial} />
                            <Route path="/caseDetail" component={CaseDetail} />
                            <Route path="/calendar" component={Calendar} />
                            <Route path="/newEditor" component={NewEditor} />
                            <Route path="/pastDue" component={PastDue} />
                            <Route path="/my" component={My} />
                            <Route path="/share" component={CallingCardShare} />
                            <Route path="/examine" component={Examine} />
                            <Route path="/card" component={CallingCard} />
                            <Route path="/credentials" component={Credentials} />
                            <Route path="/credentialsCase" component={CredentialsCase} />
                            <Route path="/lawyerSuccess" component={LawyerSuccess} />
                            <Route path="/studyList" component={StudyList} />
                            <Route path="/tgIm" component={TgIm} />
                            <Route path="/im" component={Im} />
                            <Route path="/honorDetail" component={HonorDetail} />
                            <Route path="/compile" component={CompileHonor} />
                            <Route path="/workChange" component={WorkChange} />
                            <Route path="/educationChange" component={EducationChange} />
                            <Route path="/cooperList" component={CooperList} />
                        </Switch>
                    </App>
                </ErrorBoundary>
            </Suspense>
        </Router>
    );
}

export default Routers;
